import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import store from '../../store/store'
import ProductsCarousel from '@/components/productsCarousel/productsCarousel';
import { cityParser } from '@/plugins/city_parser';
import SuperCategoriesNavigator from '@/components/superCategoriesNavigator/superCategoriesNavigator';
import ModalTemp from "@/components/modalTempClose/modalTemp";

@Component({
  components: {
    ProductsCarousel,
    SuperCategoriesNavigator,
    ModalTemp
  }
})
export default class FeaturedProducts extends Vue {
  @Action action_getRecents;

  @Getter getCity;
  @Getter getIsToken;
  @Getter getRecentProducts;

  @Mutation CURRENT_SUPER_CATEGORY;
  @Mutation CURRENT_CATEGORY;
  @Mutation CURRENT_PRODUCT;

  get superCategories() {
    let response = [];
    if (this.getCity && this.getCity.super_categories) {
      this.getCity.super_categories.map(superCategory => {
        if (
          superCategory.is_active &&
          superCategory.featured_products &&
          superCategory.featured_products.length
        ) {
          response.push(superCategory);
        }
      });
    }
    return response;
  }

  async mounted() {
    this.CURRENT_CATEGORY(null);
    this.CURRENT_PRODUCT(null);
    this.CURRENT_SUPER_CATEGORY(null);
    await store.dispatch("action_getCity", 3);
    if (this.getIsToken) {
      try {
        await this.action_getRecents();
      } catch (error) {
        // Do nothing
      }
    }
  }

  goToSuperCategory(superCategory) {
    try {
      this.CURRENT_SUPER_CATEGORY(superCategory);
      this.$router.push({
        name: "superCategories",
        query: {
          pasillo: cityParser(superCategory.name)
        }
      });
    } catch (error) {}
  }
}